'use strict';
window.Backbone = require('backbone');

Backbone.$ = window.$;

require('../../modules/home/frontend/main');

require('../../node_modules/widget-layout-assets/coffee/wls');

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvbXRydW9uZy9uYXBpc3RyYW5vL2J1aWxkLzE0Nzg4MTkxMzcwNzgtMzgwMDkvc3RhZ2luZy1wZXJmLTIwMTYuMTEuMDlfMjMuMzIvZ29vZHMtaG9tZXBhZ2UvY29yZS9mcm9udGVuZC9tYWluLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL210cnVvbmcvbmFwaXN0cmFuby9idWlsZC8xNDc4ODE5MTM3MDc4LTM4MDA5L3N0YWdpbmctcGVyZi0yMDE2LjExLjA5XzIzLjMyL2dvb2RzLWhvbWVwYWdlL2NvcmUvZnJvbnRlbmQvbWFpbi5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7QUFFQSxNQUFNLENBQUMsUUFBUCxHQUFrQixPQUFBLENBQVEsVUFBUjs7QUFDbEIsUUFBUSxDQUFDLENBQVQsR0FBYSxNQUFNLENBQUM7O0FBQ3BCLE9BQUEsQ0FBUSxrQ0FBUjs7QUFDQSxPQUFBLENBQVEsb0RBQVIifQ==
